module.exports = __webpack_public_path__ + "img/rope.2c623c5e.png";